import { colors } from './colors';

export const shadows = {
  outline: `0 0 0 3px ${colors.tangoOpacity[20]}`,
  secondaryOutline: `0 0 0 3px ${colors.vulcanOpacity[20]}`,
};
